import { NgModule  } from '@angular/core';

import { MechanicService } from './mechanics.service';

@NgModule({
  providers: [
    MechanicService
  ]
})
export class MechanicsModule {}
